import { UPLOAD, POST } from "@/core/services/store/request.module";
import { ErrorEventBus } from "@/core/lib/message.lib";
import { LineItemEventBus } from "@/core/lib/line-item/line.item.lib";
import { v4 as uuidv4 } from "uuid";
import { SET_RFQ } from "@/core/services/store/line.item.module";
import { SET_RFQ_STATUS } from "../services/store/line.item.module";

export default {
  data() {
    return {
      rfqDialog: false,
      rfqLoading: false,
      rfqProcessLoading: false,
      rfqFile: null,
      rfqContent: null,
    };
  },
  methods: {
    handleRFQFile(param) {
      this.rfqFile = this.lodash.head(param);
    },
    uploadRFQ() {
      if (!this.rfqFile?.name) {
        ErrorEventBus.$emit("update:error", "Please Select Valid Excel File.");
        return false;
      }
      const formData = new FormData();

      formData.append("file", this.rfqFile.file);

      this.rfqLoading = true;

      this.$store
        .dispatch(UPLOAD, { url: "quotation/extract-rfq", data: formData })
        .then(({ data }) => {
          this.rfqContent = data;
          this.$store.commit(SET_RFQ, {
            rfq_id: { rfqId: data.requestId },
            rfq_import_file: { fileId: data?.file?.id },
          });
          this.rfqProcessLoading = true;
          this.rfqFile = null;
          setTimeout(() => {
            this.matchRFQLineItems(data?.response?.line_items ?? []);
          }, 2000);
        })
        .catch((error) => {
          this.rfqLoading = false;
          console.log(error);
        });
    },
    rfqInitLineItem(lineItems) {
      const result = [];

      for (let index = 0; index < lineItems.length; index++) {
        const element = lineItems[index];
        if (element.found) {
          result.push(element.product);
        } else {
          const parts = element.product_name.split("|");
          const productName =
            parts.length > 0 ? parts[0].trim() : element.product_name;
          result.push({
            status: true,
            index: uuidv4(),
            uuid: uuidv4(),
            id: null,
            image: {},
            order: index + 1,
            serial_no: null,
            eq_model: null,
            location: null,
            group: null,
            discount: 0,
            type: "other",
            is_child: false,
            parent_uuid: null,
            has_child: false,
            has_property: false,
            property: {},
            group_primary: false,
            discount_value: 0,
            discount_type: 1,
            to_equipment: 0,
            product: productName,
            project_price: 0,
            threshold_price: 0,
            product_id: 0,
            product_type: "other",
            description: element.product_name,
            has_warranty: false,
            warranty: {},
            rate: 0,
            selling_cost: 0,
            quantity: element.quantity,
            uom: element.unit,
            total: 0,
            rfq: element,
          });
        }
      }

      LineItemEventBus.$emit("update:rfq-line-items", result);
      this.$store.commit(SET_RFQ_STATUS, true);
      this.$nextTick(this.cleanRFQLineItems);
    },
    cleanRFQLineItems() {
      this.rfqDialog = false;
      this.rfqLoading = false;
      this.rfqProcessLoading = false;
      this.rfqFile = null;
      this.rfqContent = null;
    },
    matchRFQLineItems(lineItems) {
      if (!lineItems?.length) {
        ErrorEventBus.$emit(
          "update:error",
          "No data found in the provided Excel file."
        );
        this.rfqLoading = false;
        return false;
      }

      this.$store
        .dispatch(POST, {
          url: "quotation/validate-rfq",
          data: { "line-items": lineItems },
        })
        .then(({ data }) => {
          this.rfqDialog = false;
          this.rfqInitLineItem(data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.rfqLoading = false;
          this.rfqProcessLoading = false;
        });
    },
  },
};
